module.exports = __webpack_public_path__ + "static/media/ge-energy.10069110.png";